import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Select from "react-select";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetClientState, getClient } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetProductCategoryState, getProductCategory } from "../../../store/productCategory/action";
import { resetCreditOptionDetailState, getCreditOptionDetail as onGetCreditOptionDetails, addNewCreditOptionDetail as onAddNewCreditOptionDetail, updateCreditOptionDetail as onUpdateCreditOptionDetail, deleteCreditOptionDetail as onDeleteCreditOptionDetail, getCreditOptionDetailLoading } from "../../../store/creditOptionDetail/action";
import { getCreditOption as onGetCreditOptions, addNewCreditOption as onAddNewCreditOption, updateCreditOption as onUpdateCreditOption, deleteCreditOption as onDeleteCreditOption, getCreditOptionLoading, resetCreditOptionState } from "../../../store/creditOption/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

const CreditOption = (props) => {
    const [modal, setModal] = useState(false);
    const [modalDetail, setModalDetail] = useState(false);
    const [activeTab, setActiveTab] = useState("1");
    const dispatch = useDispatch();

    const { productCategories, productCategoryLoading, clients, clientLoading, creditOptions, isCreditOptionCreated, isCreditOptionSuccess, loading, error, creditOptionDetails, creditOptionDetailLoading, isCreditOptionDetailCreated, isCreditOptionDetailSuccess, companies, companyLoading } = useSelector((state) => ({
        creditOptions: state.CreditOption.creditOptions,
        isCreditOptionCreated: state.CreditOption.isCreditOptionCreated,
        isCreditOptionSuccess: state.CreditOption.isCreditOptionSuccess,
        loading: state.CreditOption.loading,
        companies: state.Company.companies,
        companyLoading: state.Company.loading,
        error: state.CreditOption.error,
        creditOptionDetails: state.CreditOptionDetail.creditOptionDetails,
        creditOptionDetailLoading: state.CreditOptionDetail.loading,
        isCreditOptionDetailCreated: state.CreditOptionDetail.isCreditOptionDetailCreated,
        isCreditOptionDetailSuccess: state.CreditOptionDetail.isCreditOptionDetailSuccess,
        clients: state.Client.clients,
        clientLoading: state.Client.loading,
        productCategories: state.ProductCategory.productCategories,
        productCategoryLoading: state.ProductCategory.loading,
    }));

    const [isSearch, setIsSearch] = useState(false);
    const [clientId, setClientId] = useState(0);
    const [creditOptionList, setCreditOptionList] = useState([]);
    const [creditOption, setCreditOption] = useState([]);
    const [taskDetailAddedId, setCreditOptionDetailAddedId] = useState(0);
    const [info, setInfo] = useState([]);
    const [isExportCSV, setIsExportCSV] = useState(false);
    const [statusActive, setStatusActive] = useState([]);
    const [creditOptionDetail, setCreditOptionDetail] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [producCategoryList, setProductCategoryList] = useState([]);
    const [approveModal, setApproveModal] = useState(false);
    const [companyName, setCompanyName] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isEditDetail, setIsEditDetail] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteModalDetail, setDeleteModalDetail] = useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = useState(false);
    const [taskDetailList, setCreditOptionDetailList] = useState([]);

    const [userRole, setRoles] = useState(null);
    const [userType, setUserType] = useState("user");
    const [userData, setUserData] = useState(null);
    const [clientSelected, setClientSelect] = useState(null);
    const [companySelected, setCompanySelect] = useState(null);
    const [positionMessage, setPositionMessage] = useState("");
    const [defaultCompanyId, setDefaultCompanyId] = useState(null);

    const ref = useRef(null);

    const defaultdate = () => {
        return moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString();
    };

    const onClickDelete = (creditOption) => {
        setCreditOption(creditOption);
        setDeleteModal(true);
    };

    const onClickDeleteDetail = (creditOptionDetail) => {
        setCreditOptionDetail(creditOptionDetail);
        setDeleteModalDetail(true);
    };

    const handleDeleteCreditOption = () => {
        if (creditOption) {
            dispatch(onDeleteCreditOption(creditOption));
            setDeleteModal(false);
        }
    };

    const handleDeleteCreditOptionDetail = () => {
        if (creditOptionDetail) {
            setCreditOptionDetailAddedId(creditOptionDetail.creditOptionId);
            dispatch(onDeleteCreditOptionDetail(creditOptionDetail));
            setDeleteModalDetail(false);
        }
    };

    const onClickApprove = (employee) => {
        setCreditOption(employee);
        setApproveModal(true);
    };

    useEffect(() => {
        setIsLoading(loading);
    }, [loading]);

    const toggleTab = (tab, type) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            let filteredCreditOptions = creditOptions;
            if (type !== "all") {
                filteredCreditOptions = creditOptions.filter((creditOption) => creditOption.credit_option_status.name === type);
            }
            setCreditOptionList(filteredCreditOptions);
        }
    };

    useEffect(() => {
        if (!isSearch) {
            setIsSearch(true);
            const obj = JSON.parse(localStorage.getItem("authUser"));
            if (obj?.data) {
                setUserData(obj.data);
                if (obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method) {
                    setRoles(obj?.data?.user?.user_position?.position_role.method);
                }
                setUserData(obj.data);
                setUserType(obj?.data?.userType);
                setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
                setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
                setClientSelect({
                    label: obj.data.client_name,
                    value: obj.data.clientId
                });
                setCompanySelect({
                    label: obj.data.company_name,
                    value: obj.data.companyId
                });

                dispatch(resetCreditOptionState());
                dispatch(onGetCreditOptions());
                dispatch(resetClientState());
                dispatch(getClient());
                handleGetCompany(obj.data.clientId);
            }
        }
    }, [dispatch, isSearch]);



    useEffect(() => {
        if (!isEmpty(creditOptions)) {
            setIsEdit(false);
            setCreditOptionList(creditOptions);
            let current = 0;
            if (taskDetailAddedId !== 0) {
                creditOptions.forEach((obj, i) => {
                    if (obj.id === taskDetailAddedId) current = i;
                });
            }
            setInfo(creditOptions[current]);
            setCreditOptionDetailList(creditOptions[current].credit_option_detail);
        }
    }, [creditOptions, taskDetailAddedId]);

    useEffect(() => {
        if (isCreditOptionDetailCreated) {
            dispatch(resetCreditOptionDetailState());
            dispatch(resetCreditOptionState());
            dispatch(onGetCreditOptions());
        }
    }, [dispatch, isCreditOptionDetailCreated]);

    useEffect(() => {
        if (!isEmpty(clients)) {
            var data = [];
            var opt = [];
            clients.forEach((item, key) => {
                const name = item.name;
                const id = item.id;
                var obj = { label: name, value: id };
                opt.push(obj);
            });
            var option = { options: opt };
            data.push(option);
            setClientList(data);
        }
    }, [clients]);

    useEffect(() => {
        var data = [];
        var opt = [];
        (companies || []).forEach((item, key) => {
            const name = item.name;
            const id = item.id;
            var obj = { label: name, value: id };
            opt.push(obj);
        });
        var option = { options: opt };
        data.push(option);

        if (companies.length > 0) {
            setCompanyList(data);
        }
    }, [companies]);

    useEffect(() => {
        var data = [];
        var opt = [];
        productCategories.forEach((item, key) => {
            const name = item.name;
            const id = item.id;
            var obj = { label: name, value: id };
            opt.push(obj);
        });
        var option = { options: opt };
        data.push(option);

        if (productCategories.length > 0) {
            setProductCategoryList(data);
        }
    }, [productCategories]);

    const [filterDate, setFilterDate] = useState(null);

    const handleValidDate = (date) => {
        return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
    };

    const toggle = useCallback(() => {
        if (modal) {
            setModal(false);
            setCreditOption(null);
            validation.resetForm();
            validation.setErrors({});
        } else {
            setModal(true);
            dispatch(getClient());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modal]);

    const handleCreditOptionClick = useCallback((arg) => {
        const data = arg;
        setCreditOption({
            id: data.id,
            name: data.name,
            description: data.description,
            client:
                data.credit_option_client && {
                    label: data.credit_option_client ? data.credit_option_client.name : "",
                    value: data.credit_option_client ? data.credit_option_client.id : "",
                },
            company:
                data.credit_option_company && {
                    label: data.credit_option_company ? data.credit_option_company.name : "",
                    value: data.credit_option_company ? data.credit_option_company.id : "",
                },
            productCategory:
                data.credit_option_category && {
                    label: data.credit_option_category ? data.credit_option_category.name : "",
                    value: data.credit_option_category ? data.credit_option_category.id : "",
                },
        });

        setIsEdit(true);
        toggle();
    },
        [toggle, userType]
    );

    const toggleDetail = useCallback(() => {
        if (modalDetail) {
            setModalDetail(false);
            setCreditOptionDetail(null);
            setCreditOption(null);
        } else {
            setModalDetail(true);
        }
    }, [modalDetail]);

    const handleCreditOptionDetailClick = useCallback((arg, arginfo, isEdit) => {
        const data = arg;
        setCreditOptionDetail({
            id: data.id,
            creditOptionId: data.creditOptionId,
            name: data.name,
            amount: data.amount,
            description: data.description,
        });

        setIsEditDetail(isEdit);
        toggleDetail();
    },
        [toggleDetail]
    );

    const columns = useMemo(
        () => [
            {
                Header: " ",
                maxWidth: 100,
                filterable: false,
                Cell: (cellProps) => {
                    return (
                        <div className="hstack gap-2 mt-4 mt-sm-0">
                            {cellProps.row.original.statusId === 1 ? (
                                <button
                                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : userRole && userRole.split(",").indexOf("approveCreditOption") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-0" : "btn-label btn btn-sm btn-soft-success fs-12 me-0 d-none"}
                                    onClick={() => {
                                        let data = cellProps.row.original;
                                        onClickApprove(data);
                                    }}>
                                    <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                                    Approve
                                </button>
                            ) : (
                                ""
                            )}
                            <Link
                                to="#"
                                className="btn-icon btn btn-sm btn-light"
                                onClick={() => {
                                    setInfo(cellProps.row.original);
                                    setCreditOptionDetailList(cellProps.row.original.credit_option_detail);
                                    ref.current?.scrollIntoView({ behavior: "smooth" });
                                }}>
                                <i className="ri-eye-line fs-15"></i>
                            </Link>
                            <Link
                                to="#"
                                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-light edit-item-btn" : userRole && userRole.split(",").indexOf("updateCreditOption") !== -1 ? "btn-icon btn btn-sm btn-light edit-item-btn" : "btn-icon btn btn-sm btn-light edit-item-btn d-none"}
                                onClick={() => {
                                    handleCreditOptionClick(cellProps.row.original);
                                }}>
                                <i className="ri-edit-2-line fs-15"></i>
                            </Link>
                            <Link
                                to="#"
                                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : userRole && userRole.split(",").indexOf("deleteCreditOption") !== -1 ? "btn-icon btn btn-sm btn-soft-danger remove-item-btn" : "btn-icon btn btn-sm btn-soft-danger remove-item-btn d-none"}
                                onClick={() => {
                                    const creditOptionData = cellProps.row.original;
                                    onClickDelete(creditOptionData);
                                }}>
                                <i className="ri-delete-bin-line fs-15 text-danger"></i>
                            </Link>
                        </div>
                    );
                },
            },
            {
                Header: "Credit Name",
                accessor: "name",
                filterable: true,
            },
            {
                Header: "Keterangan",
                accessor: "description",
                filterable: true,
            },
            {
                Header: "Status",
                accessor: "credit_option_status.name",
                filterable: true,
                Cell: (cell) => {
                    switch (cell.value) {
                        case "DRAFT":
                            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
                        case "ACTIVE":
                            return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
                        case "INACTIVE":
                            return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
                        default:
                            return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
                    }
                },
            },
        ],
        [handleCreditOptionClick, userType, userRole]
    );

    const {
        getTableProps, rows,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        preGlobalFilteredRows,
        setGlobalFilter,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns: columns,
            data: creditOptionList,
            defaultColumn: { Filter: null },
            initialState: {
                pageIndex: 0,
                pageSize: 8,
                selectedRowIds: 0,
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect
    );

    const columnsSecond = useMemo(
        () => [{
            Header: " ",
            maxWidth: 100,
            filterable: false,
            Cell: (cellProps) => {
                return (
                    <div className="hstack gap-2 mt-4 mt-sm-0">
                        <Link
                            to="#"
                            className={"btn-icon btn btn-sm btn-light edit-item-btn"}
                            onClick={() => {
                                handleCreditOptionDetailClick(cellProps.row.original, info, true);
                            }}><i className="ri-edit-2-line fs-15"></i>
                        </Link>
                    </div>
                );
            },
        },
        {
            Header: `${props.t("Nama")}`,
            accessor: "name",
            filterable: true,
        },
        {
            Header: `${props.t("Amount")}`,
            accessor: "amount",
            filterable: true,
        },
        {
            Header: `${props.t("Company")}`,
            accessor: "credit_option_company.name",
            filterable: true,
        },
        {
            Header: `${props.t("Description")}`,
            accessor: "description",
            filterable: true,
        }],
        [handleCreditOptionDetailClick, props, info, taskDetailList]
    );

    const {
        getTableProps: getTablePropsSecond,
        getTableBodyProps: getTableBodyPropsSecond,
        headerGroups: headerGroupsSecond,
        page: pageSecond,
        prepareRow: prepareRowSecond,
        canPreviousPage: canPreviousPageSecond,
        canNextPage: canNextPageSecond,
        pageOptions: pageOptionsSecond,
        gotoPage: gotoPageSecond,
        nextPage: nextPageSecond,
        previousPage: previousPageSecond,
        setPageSize: setPageSizeSecond,
        preGlobalFilteredRows: preGlobalFilteredRowsSecond,
        setGlobalFilter: setGlobalFilterSecond,
        state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
    } = useTable(
        {
            columns: columnsSecond,
            data: taskDetailList,
            defaultColumn: { Filter: null },
            initialState: {
                pageIndex: 0,
                pageSize: 8,
                selectedRowIds: 0,
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect
    );

    const generateSortingIndicator = (column) => {
        return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
    };

    const generateFilterable = (column) => {
        return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
    };

    const onChangeInSelect = (event) => {
        setPageSize(Number(event.target.value));
    };

    const onChangeInInput = (event) => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0;
        gotoPage(page);
    };

    const count = preGlobalFilteredRows.length;
    const [searchValue, setSearchValue] = useState([]);
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 200);

    const countSecond = preGlobalFilteredRowsSecond.length;
    const [searchValueSecond, setSearchValueSecond] = useState([]);

    const handleApproveCreditOption = () => {
        if (creditOption) {
            creditOption.setApprove = true;
            dispatch(onUpdateCreditOption(creditOption));
            setApproveModal(false);
        }
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            client: (creditOption && creditOption.client) || clientSelected,
            company: (creditOption && creditOption.company) || companySelected,
            name: (creditOption && creditOption.name) ?? "",
            productCategory: (creditOption && creditOption.productCategory) ?? "",
            position: creditOption && creditOption.position,
            description: (creditOption && creditOption.description) ?? "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Credit Name").nullable(true),
            client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
            company: Yup.object().required("Please Select Company").nullable(true),
        }),
        onSubmit: (values) => {
            dispatch(getCreditOptionLoading());
            if (isEdit) {
                const updateCreditOption = {
                    id: creditOption ? creditOption.id : 0,
                    name: values.name,
                    categoryId: values.productCategory.value,
                    description: values.description,
                    clientId: values.client.value,
                    companyId: values.company.value,
                    statusId: 2,
                };
                dispatch(onUpdateCreditOption(updateCreditOption));
                validation.resetForm();
            } else {
                const newCreditOption = {
                    name: values.name,
                    categoryId: values.productCategory.value,
                    description: values.description,
                    clientId: values.client.value,
                    companyId: values.company.value,
                    statusId: 2,
                };
                dispatch(onAddNewCreditOption(newCreditOption));
                validation.resetForm();
            }
            toggle();
        },
    });

    const validationDetail = useFormik({
        enableReinitialize: true,
        initialValues: {
            creditOptionId: info.id,
            name: (creditOptionDetail && creditOptionDetail.name) ?? "",
            amount: (creditOptionDetail && creditOptionDetail.amount) ?? "",
            description: (creditOptionDetail && creditOptionDetail.description) ?? "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter Sub CreditOption Title").nullable(true),
        }),
        onSubmit: (values) => {
            setCreditOptionDetailAddedId(values.creditOptionId);
            dispatch(getCreditOptionDetailLoading());
            if (isEditDetail) {
                const updateCreditOptionDetail = {
                    id: creditOptionDetail ? creditOptionDetail.id : 0,
                    name: values.name,
                    amount: values.amount,
                    description: values.description,
                    creditOptionId: values.creditOptionId,
                };
                dispatch(onUpdateCreditOptionDetail(updateCreditOptionDetail));
                validationDetail.resetForm();
            } else {
                const newCreditOptionDetail = {
                    name: values.name,
                    amount: values.amount,
                    description: values.description,
                    creditOptionId: values.creditOptionId,
                };

                dispatch(onAddNewCreditOptionDetail(newCreditOptionDetail));
                validationDetail.resetForm();
            }
            toggleDetail();
        },
    });

    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".dataCheckbox");

        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        } else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };

    // Delete Multiple
    const deleteMultiple = () => {
        const ele = document.querySelectorAll(".dataCheckbox:checked");
        const checkall = document.getElementById("checkBoxAll");
        ele.forEach((element) => {
            dispatch(onDeleteCreditOptionDetail(element.value));
        });
        checkall.checked = false;
    };

    function handleFilter() {
        let startat = "";
        let endat = "";
        let datearr = filterDate?.split(" to ");
        if (datearr[1]) {
            startat = datearr[0];
            endat = datearr[1] ? datearr[1] : datearr[0];
        }
        var status = statusActive.value ? statusActive.value : "";
        const param = {
            title: searchValue,
            startat: startat,
            endat: endat,
            status: status,
        };
        dispatch(onGetCreditOptions(param));
    }

    const handleGetCompany = (id) => {
        dispatch(resetCompanyState());
        dispatch(getCompany({ clientId: id }));
    };

    const handleGetProductCategory = (companyId) => {
        dispatch(resetProductCategoryState());
        dispatch(getProductCategory({ companyId: companyId }));
    };

    document.title = "Template Credit Option | Enterprise Resources Planning";

    return (
        <div className="page-content">
            <ApproveModal data={creditOption && creditOption.name} show={approveModal} onApproveClick={handleApproveCreditOption} onCloseClick={() => setApproveModal(false)} />
            <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCreditOption} onCloseClick={() => setDeleteModal(false)} />
            <DeleteModal show={deleteModalDetail} onDeleteClick={handleDeleteCreditOptionDetail} onCloseClick={() => setDeleteModalDetail(false)} />
            <DeleteModal
                show={deleteModalMulti}
                onDeleteClick={() => {
                    deleteMultiple();
                    setDeleteModalMulti(false);
                }}
                onCloseClick={() => setDeleteModalMulti(false)}
            />
            <Container fluid>
                <BreadCrumb title="Credit Option" pageTitle="Credit Option" />
                <Row>
                    <Col xxl={6}>
                        <Card>
                            <CardHeader className="card-header border-0">
                                <div className="d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">
                                        Credit Option &nbsp;
                                        {isLoading ? (
                                            <>
                                                <Spinner color="primary" type="grow" size={"sm"}>
                                                    Loading...
                                                </Spinner>
                                                &nbsp;
                                                <Spinner color="success" type="grow" size={"sm"}>
                                                    Loading...
                                                </Spinner>
                                                &nbsp;
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </h5>
                                    <div className="flex-shrink-0">
                                        <button
                                            type="button"
                                            className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createCreditOption") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
                                            id="create-btn"
                                            onClick={() => {
                                                setIsEdit(false);
                                                toggle();
                                            }}>
                                            <i className="ri-task-line me-1 align-bottom fs-14"></i> Tambah
                                        </button>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardBody className="pt-0">
                                <div>
                                    <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("1", "all");
                                                }}
                                                href="#"
                                            >
                                                <i className="ri-task-line me-1 align-bottom fs-14"></i> All Credit Option
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("2", "DRAFT");
                                                }}
                                                href="#"
                                            >
                                                <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("3", "ACTIVE");
                                                }}
                                                href="#"
                                            >
                                                <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                                                onClick={() => {
                                                    toggleTab("4", "INACTIVE");
                                                }}
                                                href="#"
                                            >
                                                <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                    <Row className="mb-3">
                                        <CardBody className="border border-top-0 border-end-0 border-start-0">
                                            <form>
                                                <Row>
                                                    <Col sm={1}>
                                                        <div className="me-2 mb-2 col-12">
                                                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                                                    <option key={pageSize} value={pageSize}>
                                                                        {pageSize}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </Col>
                                                    <Col sm={7}>
                                                        <div className="search-box me-2 mb-2 d-inline-block col-12">
                                                            <input
                                                                onChange={(e) => {
                                                                    setSearchValue(e.target.value);
                                                                    onChange(e.target.value);
                                                                    gotoPage(0);
                                                                }}
                                                                id="search-bar-0"
                                                                type="text"
                                                                className="form-control search"
                                                                placeholder={`${count} Search...`}
                                                                value={searchValue ?? ""}
                                                            />
                                                            <i className="bx bx-search-alt search-icon"></i>
                                                        </div>
                                                    </Col>
                                                    <Col className="col-xxl-3">
                                                        <div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-light w-100"
                                                                onClick={() => {
                                                                    handleFilter();
                                                                }}
                                                            >
                                                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                                                            </button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </form>
                                        </CardBody>
                                    </Row>
                                    <div className="table-responsive table-card mb-1">
                                        <Table hover {...getTableProps()} className="align-middle table-nowrap">
                                            <thead className="table-light">
                                                {headerGroups.map((headerGroup, index) => (
                                                    <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                                                        {headerGroup.headers.map((column, index) => (
                                                            <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                                                {column.render("Header")}
                                                                {generateSortingIndicator(column)}
                                                                {/* <Filter column={column} /> */}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>
                                            <tbody {...getTableBodyProps()}>
                                                {page.map((row) => {
                                                    prepareRow(row);
                                                    return (
                                                        <Fragment key={row.getRowProps().key}>
                                                            <tr>
                                                                {row.cells.map((cell, index) => {
                                                                    return (
                                                                        <td {...cell.getCellProps()} key={index}>
                                                                            {cell.render("Cell")}
                                                                        </td>
                                                                    );
                                                                })}
                                                            </tr>
                                                        </Fragment>
                                                    );
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>

                                    <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                                        <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                                        <Col className="col-md-auto">
                                            <div className="d-flex gap-1">
                                                <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                                                    {"<"}
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto d-none d-md-block">
                                            Page
                                            <strong>
                                                {pageIndex + 1} of {pageOptions.length}                    </strong>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="d-flex gap-1">
                                                <Button color="light" onClick={nextPage} disabled={!canNextPage}>
                                                    {">"}
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <Modal id="showModal" isOpen={modal} centered size="md">
                                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                                        {!!isEdit ? "Edit Credit Option List" : "Add Credit Option List"}
                                    </ModalHeader>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}>
                                        <ModalBody>
                                            <div className="row">
                                                <div className="mb-3">
                                                    <Label htmlFor="client-field" className="form-label">
                                                        Grup Usaha&nbsp; {clientLoading && (
                                                            <Spinner color="primary" size="sm">
                                                                Loading...
                                                            </Spinner>
                                                        )}
                                                    </Label>
                                                    <Select
                                                        name="client"
                                                        value={validation.values.client}
                                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                                        placeholder="Pilih Grup Usaha"
                                                        onChange={(e) => {
                                                            setCompanyList([]);
                                                            setProductCategoryList([])
                                                            validation.setFieldValue("company", "");
                                                            validation.setFieldValue("productCategory", []);
                                                            validation.setFieldValue("client", e);
                                                            handleGetCompany(e.value);
                                                        }}
                                                        options={clientList}
                                                    ></Select>
                                                </div>
                                                <div className="mb-3">
                                                    <Label htmlFor="company-field" className="form-label">
                                                        Perusahaan&nbsp; {companyLoading && (
                                                            <Spinner color="primary" size="sm">
                                                                Loading...
                                                            </Spinner>
                                                        )}
                                                    </Label>
                                                    <Select
                                                        name="company"
                                                        value={validation.values.company}
                                                        placeholder="Pilih Perusahaan"
                                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                                        onChange={(e) => {
                                                            setProductCategoryList([])
                                                            validation.setFieldValue("productCategory", []);
                                                            validation.setFieldValue("company", e);
                                                            handleGetProductCategory(e.value);
                                                        }}
                                                        options={companyList}
                                                    ></Select>
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="productCategory-field" className="form-label">
                                                        Product Category&nbsp;
                                                        {productCategoryLoading ? (
                                                            <Spinner color="primary" size="sm">
                                                                Loading...
                                                            </Spinner>
                                                        ) : (
                                                            ""
                                                        )}
                                                    </Label>
                                                    <Select
                                                        name="productCategory"
                                                        value={validation.values.productCategory}
                                                        placeholder="Select Product Category"
                                                        isDisabled={producCategoryList.length > 0 ? false : true}
                                                        onChange={(e) => {
                                                            validation.setFieldValue("productCategory", e);
                                                        }}
                                                        options={producCategoryList}
                                                    ></Select>
                                                    {validation.touched.productCategory && validation.errors.productCategory ? (
                                                        <small className="text-danger" type="invalid">
                                                            {validation.errors.productCategory}
                                                        </small>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3 col-lg-12">
                                                    <Label htmlFor="name-field" className="form-label">
                                                        Credit Option Title
                                                    </Label>
                                                    <Input name="name" id="name-field" className="form-control" placeholder="Credit Option Name" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                                    {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                                                </div>
                                                <div className="mb-3 col-lg-12">
                                                    <Label htmlFor="description-field" className="form-label">
                                                        Description
                                                    </Label>
                                                    <Input name="description" id="description-field" rows="7" className="form-control" placeholder="Enter Credit Option Description" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} />
                                                </div>
                                            </div>
                                        </ModalBody>
                                        <div className="modal-footer">
                                            <div className="hstack gap-2 justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-light"
                                                    onClick={() => {
                                                        setModal(false);
                                                    }}
                                                >
                                                    Close
                                                </button>
                                                <button type="submit" className="btn btn-success">
                                                    <span className="d-flex align-items-center">
                                                        <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Add Credit Option List"}</span>
                                                        {loading && (
                                                            <Spinner size="sm" className="flex-shrink-0" role="status">
                                                                Loading...
                                                            </Spinner>
                                                        )}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                </Modal>
                                <Modal id="showModalDetail" isOpen={modalDetail} centered size="md">
                                    <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                                        {!!isEditDetail ? "Edit Sub Credit Option" : "Add Sub Credit Option"}
                                    </ModalHeader>
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validationDetail.handleSubmit();
                                            return false;
                                        }}>
                                        <ModalBody>
                                            <div className="row">
                                                <div className="mb-3 col-lg-12">
                                                    <Label htmlFor="name-field" className="form-label">
                                                        Sub Credit Option Title
                                                    </Label>
                                                    <Input name="name" id="name-field" className="form-control" placeholder="Enter Sub Credit Option Title" type="text" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.name} invalid={validationDetail.touched.name && validationDetail.errors.name ? true : false} />
                                                    {validationDetail.touched.name && validationDetail.errors.name ? <FormFeedback type="invalid">{validationDetail.errors.name}</FormFeedback> : null}
                                                </div>
                                                <div className="mb-3 col-lg-12">
                                                    <Label htmlFor="amount-field" className="form-label">
                                                        Credit Option Amount
                                                    </Label>
                                                    <Input name="amount" id="amount-field" className="form-control" placeholder="Enter Credit Option Amount" type="number" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.amount} invalid={validationDetail.touched.amount && validationDetail.errors.amount ? true : false} />
                                                    {validationDetail.touched.amount && validationDetail.errors.amount ? <FormFeedback type="invalid">{validationDetail.errors.amount}</FormFeedback> : null}
                                                </div>
                                                <div className="mb-3 col-lg-12">
                                                    <Label htmlFor="description-field" className="form-label">
                                                        Description
                                                    </Label>
                                                    <Input name="description" id="description-field" rows="7" className="form-control" placeholder="Enter Sub Credit Option Description" type="textarea" onChange={validationDetail.handleChange} onBlur={validationDetail.handleBlur} value={validationDetail.values.description} />
                                                </div>
                                            </div>
                                        </ModalBody>
                                        <div className="modal-footer">
                                            <div className="hstack gap-2 justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-light"
                                                    onClick={() => {
                                                        setModalDetail(false);
                                                    }}
                                                >
                                                    Close
                                                </button>
                                                <button type="submit" className="btn btn-success">
                                                    <span className="d-flex align-items-center">
                                                        <span className="flex-grow-1 me-2">{!!isEditDetail ? "Update" : "Add Sub Credit Option"}</span>
                                                        {loading && (
                                                            <Spinner size="sm" className="flex-shrink-0" role="status">
                                                                Loading...
                                                            </Spinner>
                                                        )}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                </Modal>

                            </CardBody>
                        </Card>
                    </Col>
                    <Col xxl={6}>
                        <Card>
                            <div className="card-body d-flex align-items-center">
                                <h5 className="text-uppercase mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
                                <div className="flex-shrink-0">
                                    <button
                                        type="button"
                                        className="btn btn-success add-btn"
                                        id="create-btn"
                                        onClick={() => {
                                            setIsEditDetail(false);
                                            toggleDetail();
                                            // var data = [];
                                            // var opt = [{ label: "Select All", value: "all" }];
                                            // info.pc_detail &&
                                            //   info.pc_detail.forEach((item, key) => {
                                            //     if (item.component_type === "Allowance") {
                                            //       const name = item.name;
                                            //       const id = item.id;
                                            //       var obj = { label: name, value: id };
                                            //       opt.push(obj);
                                            //     }
                                            //   });
                                            // var option = { options: opt };
                                            // data.push(option);
                                            // setSelectedAllowance(data);
                                        }}>
                                        <i className="ri-list-check label-icon align-middle fs-13 me-1"></i>
                                        {props.t("Add")} {props.t("Sub Credit Option")}
                                    </button>
                                    {/* <button
                      className="btn btn-soft-danger"
                      onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line me-1 align-bottom fs-13"></i>
                    </button> */}
                                </div>
                            </div>
                            <div className="card-body">
                                {/* <Grid
                  data={billingComponentList || []}
                  columns={[
                    {
                      id: "actionchecked",
                      name: _(<input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />),
                      width: "4%",
                      sort: false,
                      data: (row) => row.id,
                      formatter: (cell) => _(<input type="checkbox" className="dataCheckbox form-check-input" value={cell} />),
                    },
                    {
                      name: Nama,
                      data: (row) => row.name,
                      width: "18%",
                    },
                    {
                      name: "Type",
                      width: "10%",
                      data: (row) => row.type,
                    },
                    {
                      name: "Period",
                      width: "14%",
                      data: (row) => row.period,
                    },
                    {
                      name: "Amount",
                      width: "14%",
                      data: (row) => row.amount,
                    },
                    {
                      name: "Status",
                      width: "10%",
                      data: (row) => row,
                      formatter: (cell) => _(<span className={cell.billing_component_status.id === 1 ? "badge text-uppercase badge-soft-danger" : cell.billing_component_status.id === 2 ? "badge text-uppercase badge-soft-info" : "badge text-uppercase badge-soft-warning"}>{cell.billing_component_status.id === 2 ? "ACTIVE" : cell.billing_component_status.id === 1 ? "DRAFT" : ""}</span>),
                    },
                    {
                      name: "action",
                      sort: false,
                      width: "9%",
                      data: (row) => row,
                      formatter: (cell) =>
                        _(
                          <div className="hstack gap-2 mt-4 mt-sm-0">
                            <button
                              className="btn-icon btn btn-sm btn-light edit-item-btn"
                              onClick={() => {
                                handleBillingDetailClick(cell, info, true);
                              }}><i className="ri-edit-2-line fs-15"></i>
                            </button>
                            {cell.statusId !== 2 ? (
                              <button
                                to="#"
                                className="btn-icon btn btn-sm btn-soft-danger remove-item-btn"
                                onClick={() => {
                                  onClickDeleteDetail(cell);
                                }}><i className="ri-delete-bin-line fs-15 text-danger"></i>
                              </button>
                            ) : null}
                          </div>
                        ),
                    },
                  ]}
    Search={true}
                  sort={true} /> */}

                                <Row>
                                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                                        <form>
                                            <Row>
                                                <Col sm={4}>
                                                    <div className="search-box me-2 mb-2 d-inline-block col-12">
                                                        <input
                                                            onChange={(e) => {
                                                                setSearchValueSecond(e.target.value);
                                                                // onChangeSecond(e.target.value);
                                                            }}
                                                            id="search-bar-0"
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder={`Search...`}
                                                            value={searchValueSecond ?? ""}
                                                        />
                                                        <i className="bx bx-search-alt search-icon"></i>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </form>
                                    </CardBody>
                                </Row>
                                <div className="table-responsive table-card mb-1">
                                    <Table hover {...getTablePropsSecond()} className="align-middle table-nowrap">
                                        <thead className="table-light">
                                            {headerGroupsSecond.map((headerGroup, index) => (
                                                <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                                                    {headerGroup.headers.map((column, index) => (
                                                        <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                                            {column.render("Header")}
                                                            {generateSortingIndicator(column)}
                                                            {/* <Filter column={column} /> */}
                                                        </th>
                                                    ))}
                                                </tr>
                                            ))}
                                        </thead>

                                        <tbody {...getTableBodyPropsSecond()}>
                                            {pageSecond.map((row) => {
                                                prepareRowSecond(row);
                                                return (
                                                    <Fragment key={row.getRowProps().key}>
                                                        <tr>
                                                            {row.cells.map((cell, index) => {
                                                                return (
                                                                    <td {...cell.getCellProps()} key={index}>
                                                                        {cell.render("Cell")}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    </Fragment>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

CreditOption.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(withTranslation()(CreditOption));
